import Heading from "../../components/heading/heading";
import ProfileLifestyles from "../../components/profile-lifestyles/profile-lifestyles";
import ProfileMenu from "../../components/profile-menu/profile-menu";

export function ProfileLifestylesPage({ withProfileMenu = false }) {
    const fromShow = withProfileMenu ? 'profile' : 'rega';

    return (
        <>
            {withProfileMenu && <ProfileMenu />}
            {!withProfileMenu && (<Heading tpl="new">Мой <span className="my-text-primary">образ жизни</span></Heading>)}
            <ProfileLifestyles fromShow={fromShow} />
        </>
    );
}
